module.exports = __webpack_public_path__ + "static/profile-pic-c715447ce38098828758e525a1128b87.jpg";